import React from 'react'

import useResetFilters from '../../../hooks/useResetFilters'
import { IconItem } from '../../IconItem'

interface Props {
  isSearching: boolean
  category?: string
}
export default function IconHome({ category, isSearching }: Props) {
  const isEnabled = !category && !isSearching
  const resetFilters = useResetFilters()

  return (
    <IconItem
      onClick={resetFilters}
      icon="home"
      label="Home"
      isEnabled={isEnabled}
    />
  )
}
